import { render, staticRenderFns } from "./questionResult.vue?vue&type=template&id=98d1465e&scoped=true&"
import script from "./questionResult.vue?vue&type=script&lang=js&"
export * from "./questionResult.vue?vue&type=script&lang=js&"
import style0 from "./questionResult.vue?vue&type=style&index=0&id=98d1465e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d1465e",
  null
  
)

export default component.exports